<div
  class="popup-area {{ popupType === 2 ? 'perfil' : '' }}
   {{ popupType === 3 ? 'preferencias' : '' }}
    {{ popupType === 4 ? 'feedback' : '' }}"
>
  <div
    class="icon icon-close"
    *ngIf="canClose"
    (click)="tryClose($event)"
  ></div>
  <app-primeiro-login *ngIf="popupType === 1"></app-primeiro-login>
  <app-perfil
    (confirmarAlteracoes)="confirmarAlteracoesChanged($event)"
    *ngIf="popupType === 2"
  ></app-perfil>
  <app-preferencias
    (confirmarAlteracoes)="confirmarAlteracoesChanged($event)"
    *ngIf="popupType === 3"
  ></app-preferencias>
  <app-feedback *ngIf="popupType === 4"></app-feedback>
</div>
